/**
 * Created by cahyo on 01/22/2018.
 */

export const getBlobFile = (dataURI: string) => {
  let data = dataURI.split(','),
    mimetypeFile = data[0].match(/:(.*?);/)[1],
    bytestring = atob(data[1]),
    index = bytestring.length, blobArray = new (<any>window).Uint8Array(index);

  while (index--) {
    blobArray[index] = bytestring.charCodeAt(index);
  }

  return new Blob([blobArray], {type: mimetypeFile});
};

export const resizeImage = (fileImage: File = null, maxSize: number = 640, name: string = ""): Promise<any> => {
  let originFileName: any = fileImage.name.split('.')[0];
  let formatFile: any = fileImage.name.split('.');
  formatFile = formatFile[formatFile.length - 1];
  formatFile = '.' + (formatFile === 'png' ? 'png' : 'jpeg');

  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const image: any = new Image();
    let reader: any = new FileReader();

    reader.addEventListener('load', function () {
      image.onload = function () {
        if (image.naturalWidth > maxSize || image.naturalHeight > maxSize) {
          if (image.naturalWidth > image.naturalHeight) {
            canvas.height = image.naturalHeight * (maxSize / image.naturalWidth);
            canvas.width = maxSize;
          } else if (image.naturalWidth < image.naturalHeight) {
            canvas.width = image.naturalWidth * (maxSize / image.naturalHeight);
            canvas.height = maxSize;
          } else {
            canvas.width = maxSize;
            canvas.height = maxSize;
          }
        } else {
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;
        }

        canvas.getContext('2d').drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight,
          0, 0, canvas.width, canvas.height);
        const src = canvas.toDataURL('image/' + formatFile, .8);
        const fileName = name ? name : originFileName + formatFile;

        resolve(new File([getBlobFile(src)], fileName));
      };

      image.src = reader.result;
      image.onerror = function () {
        reject('gagal muat gambar');
      };
    }, false);

    reader.readAsDataURL(fileImage);
  });
};
